<template>
  <div class="menu">
    <MenuItem v-for="item in menuList" :key="item.id"
      :lang="lang"
      :item="item"
      :responsive="responsive"
      :getActiveMenuId="getActiveMenuId"
      :getActiveMenuParentsIds="getActiveMenuParentsIds" />
  </div>
</template>

<script>
import MenuItem from '@/components/Nav/MenuItem.vue'

export default {
  name: 'MenuList',
  props: [
    'lang',
    'list',
    'responsive'
  ],
  components: {
    MenuItem
  },
  computed: {
    routerData () {
      // 메뉴바 활성화 체크를 위한 라우터 이름/파라미터 매치
      const routerName = getRouterName(this.$route.name)
      const routerParamKey = getRouterParamKey(routerName)
      // shortcut vars
      const shortcuts = [
        'coupon',
        'amenity',
        'control',
        'tv',
        'mypage',
        'cart',
        'myOrder',
        'morningcall',
        'parking',
        'mobility'
      ]
      const isShortcut = shortcuts.includes(routerName)
      function getRouterName (routerName) {
        // product는 product, productCategory, productDetail 모두 포함되어야 함
        return routerName.includes('product') ? 'product' : routerName
      }
      function getRouterParamKey (routerName) {
        // 라우터 이름에 따른 파라미터값
        switch (routerName) {
          case 'page':
            return 'id'
          case 'shop':
            return 'shopPageId'
          case 'product':
            return 'productId'
          case 'reservation':
            return 'reservationId'
          case 'shortcut':
            return 'shortcut'
          default:
            return null
        }
      }
      return {
        routerName: isShortcut ? 'shortcut' : routerName, // page, product, reservation, cart, mypage, ...
        routerParamKey: isShortcut ? 'shortcutId' : routerParamKey, // pageId, productId, reservationId, cart, mypage, ...
        routerParamVal: isShortcut ? routerName : this.$route.params[routerParamKey] // aa7.asdf-qwert..., cart, mypage, ...
      }
    },
    getActiveMenuId () {
      return this.$store.getters['getActiveMenuId']
    },
    getActiveMenuParentsIds () {
      return this.$store.getters['getActiveMenuParentsIds']
    }
  },
  watch: {
    '$route' (to) {
      this.setRouterActive(to.name)
    },
    list: {
      handler () {
        this.buildMenu()
      },
      immediate: true,
      deep: true
    }
  },
  mounted () {
  },
  data () {
    return {
      menuList: [],
      flattenMenu: []
    }
  },
  methods: {
    buildMenu () {
      const responsive = this.responsive

      const flatMenu = (menu) => {
        if (!menu.children || !menu.children.length) {
          return menu
        }
        return [menu, _.flatMapDeep(menu.children, flatMenu)]
      }

      const cloneMenu = _.cloneDeep(this.list) || []

      const flattenMenu = _.flatMapDeep(cloneMenu, flatMenu).map(x => {
        return {
          ...x.data,
          ...x.parent && {
            parent: x.parent
          }
        }
      })

      this.flattenMenu = flattenMenu.filter(x => {
        return (responsive === 'tablet' && !x.disabledTablet) ||
               (responsive === 'mobile' && !x.disabledMobile)
      })

      this.menuList = cloneMenu.map(x => {
        const found = flattenMenu.find(f => f.id === x.data.id)
        const isRootMenu = found && !found.parent
        return {
          ...x,
          isRoot: isRootMenu
        }
      })

      this.$nextTick(() => {
        this.setRouterActive()
      })
    },
    getMenuData (item) {
      // 메뉴바 활성화 체크를 위한 라우터 이름/파라미터 매치
      const menuType = item.type
      const menuKey = getMenuParamKey(menuType)
      function getMenuParamKey (menuType) {
        // 메뉴타입에 따른 각 id 키
        switch (menuType) {
          case 'page': // 라우터 파라미터는 id이나 메뉴를 구성하는 페이지에서의 id는 pageId임
            return 'pageId'
          case 'shop':
            return 'shopPageId'
          case 'product':
            return 'productId'
          case 'reservation':
            return 'reservationId'
          case 'shortcut':
            return 'shortcutId' // 숏컷은 shortcutId별 라우터 이름이 존재하기 때문에 별도 처리
          default: // outlink, func는 처리하지 않음
            return null
        }
      }
      return {
        menuType: menuType, // page, product, reservation, ...
        menuKey: menuKey, // pageId, productId, reservationId, ...
        menuParamVal: item[menuKey], // aa7.asdf-qwert..., cart, mypage, ...
      }
    },
    setActiveMenu () {
      const routerData = this.routerData
      this.flattenMenu.forEach((item) => {
        const menuData = item && this.getMenuData(item)
        const isActive = menuData.menuType === routerData.routerName && menuData.menuParamVal === routerData.routerParamVal
        if (isActive) {
          // 현재 메뉴정보와 라우터정보가 일치하면 이 메뉴의 id를 commit
          this.$store.commit('setActiveMenu', {id: item.id, parentsIds: item.parent || []})
        }
      })
    },
    setRouterActive (routerName) {
      const name = routerName || this.$route.name
      const setting = this.$store.getters['common/getSetting']
      const mainPageId = setting && setting.main && setting.main.page
      const exceptKey = /main|login|notfound|superadmin/
      const isMainPage = name === 'page' && this.$route.params.id === mainPageId
      if (exceptKey.test(name) || isMainPage) {
        this.$store.commit('setActiveMenu', {id: null, parentsIds: []})
      } else {
        this.setActiveMenu(routerName)
      }
    }
  }
}
</script>
